import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchSingleRecordSuccess,
    resetState,
} from './workflows.action';
import { Steps, Workflows } from './workflows.model';

export interface WorkflowsRecordsState {
    listData: Workflows[];
    singleData: Workflows;
    loading: boolean;
    error: any;
    total: number;
    steps: Steps[];
    rows: any[];
}

export const initialState: WorkflowsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    steps: [],
    rows: []
};


export const WorkflowsRecordReducer = createReducer(

    initialState,
    
    // FETCH SINGLE
    on(fetchSingleRecordSuccess, (state, { singleData, steps }) => {
        return { ...state, singleData, steps, loading: false, error: null };
    }),

    //RESET STATE
    on(resetState, () => initialState)  // Reset action handler
    
);